import { safeRedirect } from './safeRedirect';

const STORAGE_KEY = 'houzy.partner-cockpit.pending-redirect';

// Outlives the 15-minute OTP so the mail has time to arrive, without steering an abandoned request's sign-in.
const MAX_AGE_MS = 30 * 60_000;

// `localStorage`, not `sessionStorage`: a link opened from a mail client lands in a fresh tab with its own
// empty session storage.
export function rememberPendingRedirect(path: string | undefined): void {
    try {
        if (!path) {
            localStorage.removeItem(STORAGE_KEY);
            return;
        }
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ path, storedAt: Date.now() }));
    } catch {
        // Storage can be unavailable; the link then simply lands on the cockpit home.
    }
}

export function takePendingRedirect(): string | undefined {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        localStorage.removeItem(STORAGE_KEY);
        const parsed: unknown = raw === null ? null : JSON.parse(raw);
        if (typeof parsed !== 'object' || parsed === null) {
            return undefined;
        }
        const { path, storedAt } = parsed as { path?: unknown; storedAt?: unknown };
        if (typeof path !== 'string' || typeof storedAt !== 'number' || Date.now() - storedAt > MAX_AGE_MS) {
            return undefined;
        }
        const target = safeRedirect(path, '');
        return target === '' ? undefined : target;
    } catch {
        return undefined;
    }
}
